import type { InputHTMLAttributes, ReactNode } from "react";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: ReactNode;
  description?: ReactNode;
}

export function Checkbox({ label, description, className, ...rest }: CheckboxProps): React.JSX.Element {
  return (
    <label className={`nb-check-row${className ? ` ${className}` : ""}`}>
      <input type="checkbox" className="nb-check" {...rest} />
      <span>
        {label}
        {description ? <span className="nb-check-desc">{description}</span> : null}
      </span>
    </label>
  );
}
